import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterSearchDropdownIcon from './VeltCommentsSidebarFilterSearchDropdownIcon/VeltCommentsSidebarFilterSearchDropdownIcon';
import VeltCommentsSidebarFilterSearchHiddenCount from './VeltCommentsSidebarFilterSearchHiddenCount/VeltCommentsSidebarFilterSearchHiddenCount';
import VeltCommentsSidebarFilterSearchInput from './VeltCommentsSidebarFilterSearchInput/VeltCommentsSidebarFilterSearchInput';
import VeltCommentsSidebarFilterSearchTags from './VeltCommentsSidebarFilterSearchTags/VeltCommentsSidebarFilterSearchTags';
var VeltCommentsSidebarFilterSearch = function (props) {
    var children = props.children, placeholder = props.placeholder, remainingProps = __rest(props, ["children", "placeholder"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-wireframe", __assign({}, transformedProps, { placeholder: placeholder }), children));
};
VeltCommentsSidebarFilterSearch.DropdownIcon = VeltCommentsSidebarFilterSearchDropdownIcon;
VeltCommentsSidebarFilterSearch.Tags = VeltCommentsSidebarFilterSearchTags;
VeltCommentsSidebarFilterSearch.HiddenCount = VeltCommentsSidebarFilterSearchHiddenCount;
VeltCommentsSidebarFilterSearch.Input = VeltCommentsSidebarFilterSearchInput;
export default VeltCommentsSidebarFilterSearch;
